import { Space, Upload } from 'antd';
import { AudioOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { DefaultText, PrimaryButton, styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledUploadContentWrapper = styled(Space).withConfig({
  displayName: "upload-audio-file-areacomponent__StyledUploadContentWrapper",
  componentId: "sc-1k2mhfu-0"
})(["width:100%;text-align:center;padding:24px 16px;"]);
var StyledUpload = styled(Upload).withConfig({
  displayName: "upload-audio-file-areacomponent__StyledUpload",
  componentId: "sc-1k2mhfu-1"
})(["background:#f5f5f5;display:flex;flex-direction:column;align-items:center;justify-content:center;height:250px;border:1px dashed #d9d9d9;border-radius:2px;&:hover{cursor:pointer;}.ant-upload-select{width:100%;}"]);
var StyledIcon = styled(AudioOutlined).withConfig({
  displayName: "upload-audio-file-areacomponent__StyledIcon",
  componentId: "sc-1k2mhfu-2"
})(["font-size:50px;"]);
var StyledGuide = styled.div.withConfig({
  displayName: "upload-audio-file-areacomponent__StyledGuide",
  componentId: "sc-1k2mhfu-3"
})(["text-align:center;"]);
var StyledFooter = styled.div.withConfig({
  displayName: "upload-audio-file-areacomponent__StyledFooter",
  componentId: "sc-1k2mhfu-4"
})(["display:flex;width:100%;justify-content:space-between;align-items:center;"]);
var StyledFooterText = styled(DefaultText).withConfig({
  displayName: "upload-audio-file-areacomponent__StyledFooterText",
  componentId: "sc-1k2mhfu-5"
})(["color:", ";"], styleVariables.colors.gray11);
export var UploadFileArea = function UploadFileArea(props) {
  var isMultiple = props.isMultiple,
      label = props.label,
      onBeforeUpload = props.onBeforeUpload,
      isUploading = props.isUploading,
      acceptTypes = props.acceptTypes;
  return /*#__PURE__*/_jsx(StyledUpload, {
    maxCount: 1,
    showUploadList: false,
    name: "file",
    multiple: isMultiple !== null && isMultiple !== void 0 ? isMultiple : false,
    accept: acceptTypes !== null && acceptTypes !== void 0 ? acceptTypes : 'audio/*',
    beforeUpload: function beforeUpload(file) {
      return onBeforeUpload(file);
    },
    children: /*#__PURE__*/_jsx(StyledUploadContentWrapper, {
      direction: "vertical",
      size: "middle",
      children: isUploading ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LoadingOutlined, {}), label.uploading]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledIcon, {}), /*#__PURE__*/_jsx(StyledGuide, {
          children: /*#__PURE__*/_jsx(DefaultText, {
            children: label.dragToUpload
          })
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          children: label.uploadButtonLabel
        }), /*#__PURE__*/_jsxs(StyledFooter, {
          children: [/*#__PURE__*/_jsx(StyledFooterText, {
            children: label.type
          }), /*#__PURE__*/_jsx(StyledFooterText, {
            children: label.size
          })]
        })]
      })
    })
  });
};